/* istanbul ignore file */
export var SyncSource;
(function (SyncSource) {
    SyncSource["External"] = "External";
    SyncSource["SpawnQueue"] = "SpawnQueue";
    SyncSource["ResolveQueue"] = "ResolveQueue";
    SyncSource["MoreDirtyItems"] = "MoreDirtyItems";
    SyncSource["DownloadFirst"] = "DownloadFirst";
    SyncSource["AfterDownloadFirst"] = "AfterDownloadFirst";
    SyncSource["IntegrityCheck"] = "IntegrityCheck";
    SyncSource["ResolveOutOfSync"] = "ResolveOutOfSync";
})(SyncSource || (SyncSource = {}));
